export const branding_events = {
  // Covers logo uploads too: a picked logo is only staged until Save Changes.
  partner_branding_save: {
    category: 'Partner branding',
    action: 'Operator saves branding',
    label: 'partner_branding_save',
  },
  partner_branding_asset_remove: {
    category: 'Partner branding',
    action: 'Operator removes a brand asset',
    label: 'partner_branding_asset_remove',
  },
  partner_template_save: {
    category: 'Partner branding',
    action: 'Operator saves an email or document template',
    label: 'partner_template_save',
  },
  partner_template_create: {
    category: 'Partner branding',
    action: 'Operator creates an email or document template',
    label: 'partner_template_create',
  },
  partner_template_delete: {
    category: 'Partner branding',
    action: 'Operator deletes an email or document template',
    label: 'partner_template_delete',
  },
};
